<template>
  <div>
    <section class="permanently-close-acc">
      <div class="sidebar-container"></div>
      <div class="main-contents">
        
        <div class="my-will-section">
        <v-card>
          <h3 class="decorateCls">FinTalk</h3>
          <p>
            How often do you find yourself confused with financial jargons that keep you from investing?
          </p>
          <p>
          We understand that stepping into the world of investments may not be easy for everyone.
          </p>
          <p>
           Keeping this in mind, nimeya.ai introduces FinTalk! 
          </p>
          <p>
           Stay updated about the financial world and learn about multiple investment options through FinTalk - a specialised blog by nimeya.ai for the sole purpose of making finance easy for all.
          </p>
          <p>
           Check out our latest posts and articles here.
          </p>
        <br>
          <div class="button-container">
            
            <button class="nemia-button mr-2" @click="backButton">CANCEL</button>
            <button class="nemia-button active" @click="proceedButton">
             PROCEED 
            </button>
          </div>
        </v-card>
        </div>
      </div>
    </section>
   
   
  </div>
</template>

<script>
  import axios from 'axios';
  export default {
    data : () =>({
    }),
    methods:{
      backButton(){
        this.$router.push({ name: "SudLifeFinTalk"}).catch(()=>{});
      },
       proceedButton(){
        this.$router.push({ name: "SudLifeFinTalkCategory"}).catch(()=>{});
      },
    }
  }
</script>

<style>

.will-box{
  height: 600px;
}
.will-text{
  text-align: center;
}
.breadcrumb-list li:first-child {
    color: #F19700;
}
.breadcrumb-list li {
    display: inline-block;
    padding-bottom: 6px;
    font-size: 13px;
    color: #999999;
}

.decorateCls{
  color:#F19700 !important; 
  text-decoration:underline;
}
</style>